import moment from 'moment';
import { static_options } from './options';
import XLSX from 'xlsx';
// 免疫导入
interface SheetData {
  [propertys: string]: any;
}
export const recruiting_header = {
  A1: { v: '姓名' },
  B1: { v: '手机号' },
  C1: { v: '转化负责人' },
  D1: { v: '项目跟进状态' },
  E1: { v: '创商跟进记录' },
  F1: { v: '来源' },
  G1: { v: '来源说明' },
  H1: { v: '目标期数' },
  I1: { v: '笔试成绩' },
  J1: { v: '面试时间' },
  K1: { v: '缴费日期' },
  L1: { v: '缴费金额' },
  M1: { v: '缴费渠道' }
};
export const delivery_header = {
  A1: { v: '姓名' },
  B1: { v: '手机号' },
  C1: { v: '缴费金额' },
  D1: { v: '未交付模块' },
  E1: { v: '创商班主任' },
  F1: { v: '班期' },
  G1: { v: '性别' },
  H1: { v: '同学需求' },
  I1: { v: '交付方案进展' },
  J1: { v: '互助进展' },
  K1: { v: '面试记录' },
  L1: { v: '生日' },
  M1: { v: '个人优势' },
  N1: { v: '企业亮点' }
};
export const headersToCheck = (sheet_data: any, check_infor: any) => {
  const keys_arr = Object.keys(check_infor);
  let res = true;
  keys_arr.forEach((item) => {
    if (sheet_data[item] && sheet_data[item].v != check_infor[item].v) res = false;
    else if (!sheet_data[item]) res = false;
  });
  return res;
};

/**
 * @description 获取xlsx解析的日期时间的时间戳格式
 * @param {number} v xlsxjs获取到的日期时间对象中的v值
 * @example sheet_data['A2'].v
 */
export const getTimestampByExcelTimeValue = (v: number): number => {
  const time = new Date((v - 1) * 24 * 3600000 + 1);
  time.setFullYear(time.getFullYear() - 70);
  const timestamp = moment(time).subtract(1, 'days').startOf('D').unix();

  return isNaN(timestamp) ? 0 : timestamp;
};

export const recruitingUpload = (sheet_data: SheetData, options: any): any => {
  console.log(sheet_data);

  if (!headersToCheck(sheet_data, recruiting_header)) return { res: {}, message: '文件表头错误' };

  const ref: any = sheet_data['!ref'];
  const right_string: string = ref.split(':')[1];
  const max_number = right_string.replace(/[^0-9]/gi, '');
  const arr: any = [];
  for (let index = 2; index <= Number(max_number); index++) {
    const charger_name_list = sheet_data['C' + index] ? sheet_data['C' + index].v.split(',') : [];
    const charger_id: any = [];
    const charger_name: any = [];
    charger_name_list.forEach((element: any) => {
      if (options.teacher_list.map((item: any) => item.weixin_nickname).includes(element)) {
        charger_name.push(element);
        charger_id.push(options.teacher_list.find((item: any) => item.weixin_nickname == element).id);
      }
    });

    const source_list = sheet_data['F' + index].v ? sheet_data['F' + index].v.split(',') : [];
    const source: any = [];
    source_list.forEach((element: any) => {
      if (options.source.map((item: any) => item.label).includes(element)) {
        source.push(options.source.find((item: any) => item.label == element).value);
      }
    });

    const obj = JSON.parse(
      JSON.stringify({
        name: sheet_data['A' + index] ? sheet_data['A' + index].v : '', //姓名
        mobile: sheet_data['B' + index] ? sheet_data['B' + index].v : '', //手机号

        charger_id: charger_id.join(','), //转化负责人
        charger_name: charger_name.join(','),

        status: sheet_data['D' + index] ? static_options.status.find((item) => item.label == sheet_data['D' + index].v)?.value.toString() : '', //项目跟进状态
        followup: sheet_data['E' + index] ? sheet_data['E' + index].v : '', //创商跟进记录

        source: source.join(','), //来源
        source_desc: sheet_data['G' + index] ? sheet_data['G' + index].v : '', //来源说明
        target_periods: sheet_data['H' + index] ? sheet_data['H' + index].v : '', //目标期数
        exam_score: sheet_data['I' + index] ? sheet_data['I' + index].v : '', //笔试成绩
        interview_time: sheet_data['J' + index] ? getTimestampByExcelTimeValue(sheet_data['J' + index].v) : 0, //面试时间

        fee_time: sheet_data['K' + index] ? getTimestampByExcelTimeValue(sheet_data['K' + index].v) : 0, //缴费日期
        fee: sheet_data['L' + index] ? Number(sheet_data['L' + index].v) : 0, //缴费金额
        fee_channel: sheet_data['M' + index] ? static_options.fee_channel.find((item) => item.label == sheet_data['M' + index].v)?.value : 0 //缴费渠道
      })
    );
    arr.push(obj);
  }
  return { res: arr, message: '' };
};

export const recruitingTemplate = () => {
  const output = Object.assign({}, recruiting_header);
  const ref = 'A1:M1';
  const wb = {
    SheetNames: ['招生列表模板'],
    Sheets: {
      招生列表模板: Object.assign({}, output, { '!ref': ref })
    }
  };
  XLSX.writeFile(wb, '招生列表模板.xlsx');
};

export const deliveryUpload = (sheet_data: SheetData, options: any): any => {
  if (!headersToCheck(sheet_data, delivery_header)) return { res: {}, message: '文件表头错误' };

  const ref: any = sheet_data['!ref'];
  const right_string: string = ref.split(':')[1];
  const max_number = right_string.replace(/[^0-9]/gi, '');
  const arr: any = [];
  for (let index = 2; index <= Number(max_number); index++) {
    const charger_name_list = sheet_data['E' + index] ? sheet_data['E' + index].v.split(',') : [];
    const teacher_id: any = [];
    const teacher_name: any = [];
    charger_name_list.forEach((element: any) => {
      if (options.teacher_list.map((item: any) => item.weixin_nickname).includes(element)) {
        teacher_name.push(element);
        teacher_id.push(options.teacher_list.find((item: any) => item.weixin_nickname == element).id);
      }
    });
    const undelivered_module_list = sheet_data['D' + index] ? sheet_data['D' + index].v.split(',') : [];
    const undelivered_module: any = [];
    undelivered_module_list.forEach((element: any) => {
      if (static_options.undelivered_module.map((item: any) => item.label).includes(element)) {
        undelivered_module.push(static_options.undelivered_module.find((item) => item.label == element)?.value);
      }
    });
    console.log(undelivered_module);

    const obj = JSON.parse(
      JSON.stringify({
        name: sheet_data['A' + index] ? sheet_data['A' + index].v : '', //姓名
        mobile: sheet_data['B' + index] ? sheet_data['B' + index].v : '', //手机号

        fee: sheet_data['C' + index] ? Number(sheet_data['C' + index].v) : 0, //缴费金额

        undelivered_module: undelivered_module.join(','), //未交付模块

        teacher_id: teacher_id.join(','), //创商班主任
        teacher_name: teacher_name.join(','), //创商班主任

        class_period: sheet_data['F' + index] ? sheet_data['F' + index].v : '', //班期
        gender: sheet_data['G' + index] ? static_options.gender.find((item) => item.label == sheet_data['G' + index].v)?.value : 0, //性别
        needs: sheet_data['H' + index] ? sheet_data['H' + index].v : '', //同学需求
        solution_progress: sheet_data['I' + index] ? sheet_data['I' + index].v : '', //交付方案进展
        helping_progress: sheet_data['J' + index] ? sheet_data['J' + index].v : '', //互助进展

        interview_records: sheet_data['K' + index] ? sheet_data['K' + index].v : '', //面试记录
        birthday_time: sheet_data['L' + index] ? getTimestampByExcelTimeValue(sheet_data['L' + index].v) : 0, //生日
        advantage: sheet_data['M' + index] ? sheet_data['M' + index].v : '', //个人优势
        highlights: sheet_data['N' + index] ? sheet_data['N' + index].v : '' //企业亮点
      })
    );
    arr.push(obj);
  }
  return { res: arr, message: '' };
};

export const deliveryTemplate = () => {
  const output = Object.assign({}, delivery_header);
  const ref = 'A1:N1';
  const wb = {
    SheetNames: ['交付列表模板'],
    Sheets: {
      交付列表模板: Object.assign({}, output, { '!ref': ref })
    }
  };
  XLSX.writeFile(wb, '交付列表模板.xlsx');
};
